import axios from 'axios'
import { useContext, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { LOAD, LOAD_END, LOGOUT, PATCH_PALLET_NUM } from '../../../../../../../../../store/actions/actionsTypes'
import { RootState } from '../../../../../../../../../store/reducers/rootReducer'
import { EXIST_PATH, SAVE_COMMENT_ON_PALLET, SAVE_SELECTED_GOOD } from '../../../../../../../../modules/API/settings'
import { LikutModals } from '../../../../../../../../modules/Context/CefiNum'
import { updateStatusAzmana } from '../../../../../../../../modules/requests/updateAzmanaStatus'
import { handleNotifications } from '../../../../../../../../generic/utils/handleNotifications'
import { EXTERNAL } from '../../../../../../../../modules/API/External/external'
import { vibrationFunc } from '../../../../../../../../modules/vibrationModule'
import { getOverweightFactor } from '../../../../../../../../generic/utils/overweight'
import { UseLikutEntryParams } from '../../types/likutEntry'
import { useBrodMigdal } from '../../../../../../../../generic/hooks/useBrodMigdal'
import { resolveEntryReason } from '../../../helpers/entryReason'
import { useLatchedReason } from './useLatchedReason'

const useLikutEntry = ({
    setLikutModalToggle, goodsCode, entryInformation,
    azmanotListDefault, getToken, setDefaultPacks,
    defaultPacks, likutInfo, updateExistPallets, getAzmanotDetailes,
    setInputFocus, defaultPackageList, packageType, checkForSiumLikut,
    errAlert, orderTitle, activeResons, user, persents,
    testForInitialPAcksOfAmount, isWeightCalculation, growersList
}: UseLikutEntryParams) => {
    const isOffice = user.rights.includes("OFFICE")
    const { getBrodMigdal } = useBrodMigdal()
    const isDisableTakeGoodsIfNotEnoughRest = !!getBrodMigdal({ id: 379 });
    const defaultArizaGrowerID = getBrodMigdal({ id: 412 }) as number;
    const defaultArizaTranzit = getBrodMigdal({ id: 5 }) as number;
    const defaultArizaID = getBrodMigdal({ id: 382 }) as number;
    const isEditPrice = !!getBrodMigdal({ id: 599 });
    const defaultWithoutMishtah = getBrodMigdal({ id: 14, subId: '2' }) as number
    const isSelectbleWeight = !!getBrodMigdal({ id: 573 });
    const [typeCalc, setTypeCalc] = useState(0);
    const [growerID, setGrowerID] = useState(defaultArizaGrowerID);
    const withoutSrika = (defaultPacks?.NoTagCollection || isOffice) && !goodsCode;
    // A hand-picked product (manual flow) carries placeholder order numbers
    // (OrderPacks:1/SupplyQty:0) — rest/warning math must treat it like "no
    // order row", the same way the scan flow treats a not-found product.
    const hasOrderRow = !!defaultPacks && !defaultPacks?.isManualEntry;
    
    const percentsIsAllowToOverweight = defaultPacks?.CollectDeviation || 0;
    const overweightFactor = getOverweightFactor(percentsIsAllowToOverweight);

    let initialWeigth = withoutSrika ? (defaultPacks?.OrderWeight / defaultPacks?.OrderPacks) // take weight from order
        : isWeightCalculation && entryInformation?.ProductCalculationMethod !== 1 ? (entryInformation?.AvgWeightPerPack - entryInformation?.PackageTareWeight) // take weight from srika and takes off tara (NettoNetto), brodmigdal on
            : entryInformation?.AvgWeightPerPack; // take weight from srika, brodmigdal off

    const isMandatoryWeight = entryInformation ? entryInformation.MandatoryWeight : defaultPacks.MandatoryWeight

    const selectIconForPalletType = () => {
        if (!defaultPacks?.PackID) return ''
        let filtered = defaultPackageList.filter((e: any) => e?.PackID === defaultPacks?.PackID)
        let result = filtered[0]
        return result
    }

    const { Pack_Type, Volume, Qty4Pallets } = selectIconForPalletType() as any
    console.log('Qty4Pallets', Qty4Pallets)
    console.log('Volume', Volume)
    console.log('Pack_Type', Pack_Type)
    console.log('!defaultPacks?.PackID', defaultPacks?.PackID)
    console.log('defaultPacks', defaultPacks)
    console.log('selectIconForPalletType', selectIconForPalletType())

    // calculate cost for 1 item in percents
    const costForOneItemInPercents = () => {
        if (Pack_Type === '1' || Pack_Type === '2') return 0

        return (1 / (Qty4Pallets || 60) * 100)
    }

    // -goods qty allowed to put on the pallet
    const allowedRestOfGoods = (100 - persents) / costForOneItemInPercents()

    const defaultRestGoodQty = () => {
        // condition in discussing
        if (isMandatoryWeight && Pack_Type === "1") return 0

        let restOfOrder = hasOrderRow ? defaultPacks?.OrderPacks - defaultPacks?.SupplyQty : 0;
        let restOfPallet = allowedRestOfGoods;
        let restInSrika = entryInformation?.BalanceAmount
        // Cap to the knisa (entry) balance only when brodMigdal 379 is on. When it's off we
        // ignore the entry rest entirely and give what the order needs / the pallet can hold.
        if (isDisableTakeGoodsIfNotEnoughRest && testForInitialPAcksOfAmount && (restInSrika < restOfPallet && restInSrika < restOfOrder)) return restInSrika
        if ((restOfPallet <= 0) || restOfOrder <= 0) return 0
        else if (restOfPallet > restOfOrder) return restOfOrder
        else return restOfPallet
    }
    const calcWeigthFunc = () => {

        const needWeigth = defaultRestGoodQty() * (defaultPacks?.OrderWeight / defaultPacks?.OrderPacks)
        const weigthPerOneItemInSrika = initialWeigth
        if (Pack_Type === '1') {
            return +(needWeigth / 1).toFixed(2)
        } else {
            // check the smallest discrepancy in the calculations, return lowest
            let floor = Math.floor(needWeigth / weigthPerOneItemInSrika)
            let ceil = Math.ceil(needWeigth / weigthPerOneItemInSrika)
            const calcResult = (Math.abs(needWeigth - floor * weigthPerOneItemInSrika) >= Math.abs(needWeigth - ceil * weigthPerOneItemInSrika) ? ceil : floor)
            return calcResult > 0 ? calcResult : defaultPacks?.SupplyQty === 0 ? 1 : 0
        }
    }
    // final culculation of the good rest
    const currentRestOfgoods = (isWeightCalculation || Pack_Type === '1') && (Pack_Type !== '2') ? +(calcWeigthFunc()).toFixed(2) : Math.round(defaultRestGoodQty())

    const warningMessage = () => {
        let restOfOrder = hasOrderRow ? defaultPacks?.OrderPacks - defaultPacks?.SupplyQty : 0;
        let restOfPallet = allowedRestOfGoods;
        let restInSrika = entryInformation?.BalanceAmount
        // Only warn about insufficient knisa (entry) balance when brodMigdal 379 is on.
        if (isDisableTakeGoodsIfNotEnoughRest && testForInitialPAcksOfAmount && (restInSrika < restOfPallet && restInSrika < restOfOrder)) return ['שים לב לכמות', 'אין מספיק יתרות בכניסה']
        if (restOfPallet <= 0 && restOfOrder > 0) return ['שים לב', 'אין מקום על המשטח']
        else if (restOfPallet > restOfOrder) return null
        else return ['שים לב', 'אין מקום על המשטח']
    }

    const [resonState, setResonState] = useContext<any>(LikutModals);

    // Причина (אישור מנהל и др.) живёт в volatile resonState.props и может быть
    // сброшена до клика «שמור» — латчим её с привязкой к идентичности товара:
    // подмена товара в открытой модалке (без remount) делает латч недействительным.
    const reasonIdentityKey = `${goodsCode}|${defaultPacks?.RecID ?? ''}|${defaultPacks?.ProductID ?? ''}|${defaultPacks?.VarietyID ?? ''}|${defaultPacks?.SizeID ?? ''}`
    const latchedReasonRef = useLatchedReason(resonState, reasonIdentityKey)


    const [packsQnt, setPacksQnt] = useState(currentRestOfgoods < 0 ? 0 : currentRestOfgoods);
    
    const [weights, setWeights] = useState<number | string>(
        Pack_Type !== '1' ?
            isMandatoryWeight ? 0 : packsQnt * initialWeigth
            : packsQnt
    );
    const [price, setPrice] = useState(0);
    const dispatch = useDispatch()

    const disableSaveIfCannotTakeMoreThenRest = useMemo(() => {
        return isDisableTakeGoodsIfNotEnoughRest && packsQnt > entryInformation?.BalanceAmount
    }, [packsQnt, isDisableTakeGoodsIfNotEnoughRest, entryInformation])
    const disableMessage = ['אין מספיק יתרות בכניסה']



    const handlePrice = (e: any) => {
        setPrice(e)
    }

    const acceptFunction = () => {
        if (disableSaveIfCannotTakeMoreThenRest) {
            handleNotifications(disableMessage as any, { type: "warning" })
            return
        }
        if (activeResons) {
            // ±1kg scale-jitter tolerance must not bypass the CollectDeviation ceiling:
            // sium's isAnomaly has no such tolerance, so a silent save above the ceiling
            // resurfaces later as a reasonless anomaly (ordered 1kg, gave 2kg case).
            // Math.ceil mirrors the payload ('Qty': Math.ceil(+weights)) — compare what
            // the server will actually store, not the raw scale reading.
            if (Pack_Type === '1' && Math.abs(+weights - defaultPacks?.SupplyQty - defaultPacks?.OrderPacks) <= 1
                && (Math.ceil(+weights) + defaultPacks?.SupplyQty) <= defaultPacks?.OrderPacks * overweightFactor) {
                saveSelectedGood(resonState?.props?.problemID, resonState?.props?.resonID)
                return
            }
            if (+resonState?.props?.resonID === 1) {
                if (packsQnt === calcWeigthFunc()) {

                    saveSelectedGood(resonState?.props?.problemID, resonState?.props?.resonID)
                }
                // (weights as any): legacy code concatenated when weights held a string,
                // which kept this branch from firing — preserve that exact behavior
                else if (Pack_Type === '1' && Math.abs(((weights as any) + defaultPacks?.SupplyQty) - defaultPacks?.OrderPacks) <= 2
                    && (Math.ceil(+weights) + defaultPacks?.SupplyQty) <= defaultPacks?.OrderPacks * overweightFactor) {
                    saveSelectedGood(resonState?.props?.problemID, resonState?.props?.resonID)

                }
                else {
                    // check if packtype - kg, and delta <= 1 accept to save
                    const condition = !defaultPacks?.isManualEntry && (isWeightCalculation ? packsQnt > currentRestOfgoods * overweightFactor : packsQnt > (defaultPacks ? (defaultPacks?.OrderPacks - defaultPacks?.SupplyQty) * overweightFactor : +Infinity))
                    if (condition) {

                        setResonState({
                            resonTag: 'moreThenNeed',
                            action: saveSelectedGood,
                            active: true,
                            props: {
                                setPacks: setPacksQnt,
                                calcFunc: calcWeigthFunc,
                                packType: Pack_Type,
                                defPack: defaultPacks
                            }
                        })
                    }
                    else if (!defaultPacks?.isManualEntry && packsQnt < currentRestOfgoods) {

                        setResonState({
                            resonTag: 'lessThenNeed',
                            action: saveSelectedGood,
                            active: true,
                            props: {
                                setPacks: setPacksQnt,
                                calcFunc: calcWeigthFunc,
                                packType: Pack_Type,
                                defPack: defaultPacks
                            }
                        })
                    }
                    else {
                        // if good is not exist and chosed ishur minael, added scaned good in mishtah
                        saveSelectedGood(resonState?.props?.problemID, resonState?.props?.resonID)
                    }
                }

            } else {
                const condition = !defaultPacks?.isManualEntry && (isWeightCalculation ? packsQnt > currentRestOfgoods * overweightFactor : packsQnt > (defaultPacks ? (defaultPacks?.OrderPacks - defaultPacks?.SupplyQty) * overweightFactor : +Infinity))
                if (condition) {
                    setResonState({
                        resonTag: 'moreThenNeed',
                        action: saveSelectedGood,
                        active: true,
                        props: {
                            setPacks: setPacksQnt,
                            calcFunc: calcWeigthFunc,
                            packType: Pack_Type,
                            defPack: defaultPacks
                        }
                    })
                }
                else if (!defaultPacks?.isManualEntry && packsQnt < currentRestOfgoods) {

                    setResonState({
                        resonTag: 'lessThenNeed',
                        action: saveSelectedGood,
                        active: true,
                        props: {
                            setPacks: setPacksQnt,
                            calcFunc: calcWeigthFunc,
                            packType: Pack_Type,
                            defPack: defaultPacks
                        }
                    })
                }
                else {
                    // if good is not exist and chosed ishur minael, added scaned good in mishtah
                    saveSelectedGood(resonState?.props?.problemID, resonState?.props?.resonID)
                }
            }
        }

        else {
            saveSelectedGood()
        }
    }

    const saveSelectedGood = async (problemId?: number, resonId?: number) => {
        if (weights && packsQnt === 0) {
            handleNotifications(`חובה לבחור כמות`, { type: "warning" })
            return
        }
        if (isMandatoryWeight && +weights <= 0) {
            handleNotifications(`חובה לבחור משקל`, { type: "warning" })
            return
        }
        dispatch({ type: LOAD })
        setResonState({
            resonTag: null,
            action: null,
            active: false,
            props: {}
        })
        const { ScanProblem, ChangeReason } = resolveEntryReason({
            problemId,
            resonId,
            latchedProblemId: latchedReasonRef.current.values.problemID,
            latchedResonId: latchedReasonRef.current.values.resonID,
            isWeightCalculation,
        })
        try {
            const weightFinal =
                Pack_Type === '2' || Pack_Type === "1" ? isMandatoryWeight ? +weights : +packsQnt :
                    isWeightCalculation && withoutSrika ? +weights :
                        isWeightCalculation ? (initialWeigth + (entryInformation?.ProductCalculationMethod !== 1 ? entryInformation?.PackageTareWeight : 0)) * +packsQnt
                            : +weights

            let res = await axios({
                method: withoutSrika ? 'post' : 'patch',
                url: withoutSrika ? SAVE_COMMENT_ON_PALLET : SAVE_SELECTED_GOOD,
                headers: {
                    'Authorization': 'Bearer ' + getToken
                },
                data: withoutSrika ? {
                    "QualityID": 0,
                    "WarehouseID": defaultArizaTranzit || 0,
                    "GrowerID": growerID || defaultArizaGrowerID,
                    "ProductID": defaultPacks?.ProductID,
                    'VarietyID': defaultPacks?.VarietyID,
                    'PalletNum': +likutInfo?.pallet?.palletNum,
                    'OrderNum': likutInfo?.withoutAzmana ? 0 : +likutInfo?.azmanaNum,
                    'Qty': Pack_Type === '1' ? Math.ceil(+weights) : +packsQnt,
                    'Weight': weightFinal || 0,
                    'PalletType': +likutInfo?.pallet?.palletNum === 999999 ? likutInfo?.pallet?.palletType : defaultWithoutMishtah,
                    'OrderRowRecID': defaultPacks?.RecID || 0,
                    "CustomerID": likutInfo?.withoutAzmana ? likutInfo?.clientId : 0,
                    "ScanProblem": ScanProblem,
                    "ChangeReason": ChangeReason,
                    "Type_SaleCalculation": typeCalc,
                    "PackID": likutInfo?.withoutAzmana ? defaultArizaID : defaultPacks?.PackID !== 0 ? defaultPacks?.PackID : defaultArizaID,
                    "SalePrice": price || 0

                }
                    :
                    {
                        "QualityID": 0,
                        "ProductID": 0,
                        'VarietyID': 0,
                        "Warehouse": defaultArizaTranzit || 0,
                        'EntryNum': goodsCode,
                        'PalletNum': +likutInfo?.pallet?.palletNum,
                        'OrderNum': likutInfo?.withoutAzmana ? 0 : +likutInfo?.azmanaNum,
                        'Qty': Pack_Type === '1' ? Math.ceil(+weights) : +packsQnt,
                        'Weight': weightFinal ?? 0,
                        'PalletType': +likutInfo?.pallet?.palletNum === 999999 ? likutInfo?.pallet?.palletType : defaultWithoutMishtah,
                        'OrderRowRecID': defaultPacks?.RecID || 0,
                        "CustomerID": likutInfo?.withoutAzmana ? likutInfo?.clientId : 0,
                        "ScanProblem": ScanProblem,
                        "ChangeReason": ChangeReason,
                        "Type_SaleCalculation": typeCalc,
                        "PackID": likutInfo?.withoutAzmana ? defaultArizaID : defaultPacks?.PackID !== 0 ? defaultPacks?.PackID : defaultArizaID
                    }
            })


            if (!likutInfo?.withoutAzmana) {
                updateStatusAzmana(+likutInfo?.azmanaNum, user, 1)
            }
            dispatch({ type: PATCH_PALLET_NUM, payload: res.data.palletNum });
            dispatch({ type: LOAD_END });
            handleNotifications(`פעולה בוצעה בהצלחה`, { type: "success" })

            updateExistPallets(res?.data?.palletNum);
            if (!likutInfo.withoutAzmana) {
                getAzmanotDetailes(+likutInfo?.azmanaNum);
            }
            //
            setLikutModalToggle(false);
            setInputFocus();
            checkForSiumLikut();
        } catch (err: any) {
            dispatch({ type: LOAD_END })
            setResonState({
                resonTag: 'success',
                active: true,
                props: {
                    title: 'תקלת תקשורת',
                    text: `בדוק שוב את הפריט ברשימה לאחר רענון הדף`,
                    mood: 'false'
                }
            })
            if (!err.response) {
                if (!likutInfo.withoutAzmana) {
                    getAzmanotDetailes(+likutInfo?.azmanaNum);
                }
                handleNotifications(`קרתה תקלה נסה שוב`, { type: "error" })

                setLikutModalToggle(false);
            }
            if (err?.response?.data?.data?.length > 0) {
                errAlert(err?.response?.data?.data, 'msg')
            }
            else {
                handleNotifications(`${err?.response?.data?.palletNum} ${err?.response?.data?.message}`, { type: "error" })

            }
            if (err.response?.data.message === 'jwt malformed' || err.response?.data.message === 'jwt expired') {
                dispatch({ type: LOGOUT, payload: false });
            }
        }
    }
    useEffect(() => {
        if (Pack_Type === '1') {
            setWeights(packsQnt)
        } else {
            setWeights((isMandatoryWeight ? 0 : packsQnt * initialWeigth).toFixed(2))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [packsQnt])
    const handleTypeCalc = (e: number) => {
        setTypeCalc(e)
    }
    const setScaleFunc = (value: any) => {
        if (Pack_Type === '1') {
            setPacksQnt(value);
        }
        setWeights(value)
    }

    // scales integration — same flow as knisot ModalKnisaAddProduct.fetchScale,
    // but without opening printer settings: the button is simply disabled when
    // no scales are configured
    const scales = useSelector((state: RootState) => state.printerReducer.scales)
    const [isLoadScales, setIsLoadScales] = useState(false)
    const fetchScale = async () => {
        if (!scales || scales === 0) return
        try {
            setIsLoadScales(true)
            const res = await EXTERNAL.getWeightFromScales(scales as any)
            if (!Number.isNaN(res.Weight)) {
                setScaleFunc(res.Weight)
                vibrationFunc()
            }
        } catch (err) {

        } finally {
            setIsLoadScales(false)
        }
    }

    let TitleText = withoutSrika ?
        `${defaultPacks?.ProductDesc?.trim()} ${defaultPacks?.VarietyDesc?.trim()} ${defaultPacks?.SizeID?.trim() || ''}`
        :
        `${entryInformation?.ProductDesc.trim()} ${entryInformation?.VarietyDesc.trim() || ''} ${entryInformation?.SizeDesc?.trim() || ''}`

    let GrowerName = withoutSrika ? orderTitle?.Customer_Name?.trim() : entryInformation?.GrowerName

    let bacPic = defaultPacks?.ImageUrl === '' ? 'url("https://pngicon.ru/file/uploads/otkrytaja-korobka-128x85.png") center center no-repeat' : `url("${EXIST_PATH}${defaultPacks?.ImageUrl}") center center no-repeat`

    return {
        // config
        isEditPrice,
        isSelectbleWeight,
        isMandatoryWeight,
        withoutSrika,
        Pack_Type,
        defaultArizaGrowerID,
        // fields state
        typeCalc,
        growerID,
        setGrowerID,
        packsQnt,
        setPacksQnt,
        weights,
        price,
        // calc
        currentRestOfgoods,
        disableSaveIfCannotTakeMoreThenRest,
        disableMessage,
        warningMessage,
        // handlers
        handlePrice,
        handleTypeCalc,
        setScaleFunc,
        acceptFunction,
        // scales
        isScalesAvailable: Boolean(scales),
        isLoadScales,
        fetchScale,
        // header data
        TitleText,
        GrowerName,
        bacPic,
    }
}

export default useLikutEntry;
